import { render } from "./List.vue?vue&type=template&id=745c51f8&ts=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__